import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';

import { combineLatest, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { AppState } from '../../../../reducers';
import { CreateResourceRequestAction } from '../../main.actions';
import { ResourceRequestOption, ResourceRequestOptions } from '../../main.models';
import { selectCountrySelected, selectMainFilterSelectedAccount, selectMainFilterSelectedClient } from '../../main.selectors';
import { ModalComponent } from 'atlas-modal';
import { DialogSizings } from 'atlas-cdk';

@Component({
  standalone: false,
  selector: 'dsp-resource-request-modal',
  templateUrl: './resource-request-modal.component.html',
  styleUrls: ['./resource-request-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResourceRequestModalComponent implements OnInit {

  public requestTypes: ResourceRequestOption[] = ResourceRequestOptions;
  public form: FormGroup;
  public error = false;
  public submitAttempted = false;
  public country = '';
  private readonly subscription: Subscription = new Subscription();
  public modalSize: DialogSizings = DialogSizings.xlarge;


  @ViewChild('ResourceRequestModal')
  // public modal: MosModalComponent;
  public modal: ModalComponent;


  constructor(
    private readonly store: Store<AppState>,
  ) { }

  ngOnInit() {
    this.subscription.add(this.subscribeSelectedCountry());
    this.createForm();
  }

  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      if (!isNullOrUndefined(country)) {
        this.country = country;
      }
    });
  }

  open() {
    this.createForm();
    this.submitAttempted = false;
    this.modal.launch();

  }

  private createForm(): void {
    this.form = new FormGroup({
      type: new FormControl('', [Validators.required]),
      message: new FormControl('', [Validators.required, this.validateMessage()]),
    });
  }


  cancel() {
    this.reset();
  }

  reset() {
    this.error = false;
    this.submitAttempted = false;
    this.form.reset();
    this.modal.closeModal();

  }

  public close(): void {
    this.reset();
  }

  public isSendDisabled(): boolean {
    return !this.form || this.form.invalid || this.form.pending;
  }

  submit() {
    this.submitAttempted = true;

    if (this.isSendDisabled()) {
      this.form.markAllAsTouched();
      return;
    }

    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectMainFilterSelectedAccount))
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectMainFilterSelectedAccount))
    ]).pipe(
      filter(([client, account]) => !!client && !!account),
      map(([client, account]) =>
      ({
        clientId: client._id,
        accountId: account._id,
      })
      ),
      take(1)
    ).subscribe(payload => {
      const selectedOption = ResourceRequestOptions.filter(option =>
        this.form.get('type').value === option.value
      ),
        optionDescription = (selectedOption.length > 0) ? selectedOption[0].label : '';
      this.store.dispatch(new CreateResourceRequestAction({
        ...this.form.value,
        message: this.form.get('message').value.trim(),
        country: this.country,
        accountId: payload.accountId,
        clientId: payload.clientId,
        subject: `${optionDescription}`,
        isServiceRequest: true
      }));
    });
    this.reset();
  }

  requestMessageFocus() {
    if (this.form.get('type').value === '') {
      this.form.get('type').setErrors({ required: true });
      this.error = true;
    }
  }

  onResourceTypeChange(value) {
    if (value) {
      this.error = false;
    }
  }

  private validateMessage(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const text: string = control.value;
      return !text.replace(/(\r\n\t|\n|\r\t)/gm, '').match(/(?!^ +$)^.+$/) ? { blank: true } : null;
    };
  }
}
